<template>
	<div class="hero-static content content-full bg-body-extra-light block block-rounded shadow my-5">
		<div class="block block-transparent">
			<div class="block-content block-content-full p-0">
				<img src="/media/banners/gold_lifetime_membership.jpg" style="object-fit: cover;height: 100%;width: 100%;" />
			</div>
		</div>
		<div class="content">
			<div v-if="ops_lifetime!==null && ops_lifetime.has_ops_lifetime=='yes'">
				<div v-if="ops_lifetime.status=='S'" class="block block-rounded">
					<div class="block-content block-content-full">
						<h3 class="text-center">Thank you for joining us as a Gold Lifetime Member.</h3>
					</div>
				</div>
				<BankAccountTemplate v-else :data="ops_lifetime" />
			</div>

			<div v-if="(is_allowed==1 && (!ops_lifetime || ops_lifetime.has_ops_lifetime=='no'))" class="block block-rounded">
				<div class="block-content block-content-full">
					<div class="row">
						<h2>A Special 60th Birthday Treat for Gold Members</h2>
						<p class="lead">Upgrade to TRC Gold Lifetime Membership by July 17, 2026, and be among the first 60 Gold members invited to dinner with Bro. Bo.</p>

						<p>Hi {{capitalized(user.fname)}},</p>
						<p>I'm turning 60 years old.</p>
						<p>Wow.</p>
						<p>Imagine that.</p>
						<p>Let me become sentimental for a moment. I think about the past years that have gone by, the memories, and how good God has been towards me and my family. Now, I'm starting my journey towards becoming a senior citizen. And yes, I'm excited to have senior citizen discounts soon!</p>
						<p>Kidding aside.</p>
						<p>One of the treasures God has given me is the TrulyRich Club.</p>
						<p>This community that I founded years ago and continues with its mission of helping you achieve financial freedom.</p>
						<p>And for my 60th Birthday this year we're having a celebration!</p>
						<p>For the first 60 Gold members who will upgrade to our TRC Lifetime Gold Membership, the dinner is on me! (one time only)</p>
						<p>I'm excited about the deeper kwentuhan we'll have. Slots are very limited to the first 60 members because I want our dinner to be personal and close-knit.</p>
						<p>Did you know how I got the idea of the TRC Lifetime Gold Membership?</p>
						<p>It's because from time to time I encounter TRC members who would like to become members forever!</p>
						<p>I got blown away by that suggestion. And that means many have been blessed by our financial community that they want to secure their spot in TRC for a lifetime!</p>
						<p>Imagine... No renewals. No missed seats. Just guaranteed access, premium privileges, and lifelong savings.</p>
						<p>Just pure, uninterrupted access to everything the TrulyRichClub offers, year after year after year, for the rest of your life.</p>

						<h4>Here's everything included in your one-time investment:</h4>
						<ul style="padding-left: 30px;">
							<li>Lifetime Access to TRC Premium Tools — Stock Alerts, Wealth Strategies, and Market Updates, with no expiry</li>
							<li>1 Free Diamond Event Ticket every year</li>
							<li>1 Free Platinum Event Ticket every year</li>
							<li>5 Free Tickets to TRC Wealth Conference annually</li>
							<li>Premium Seating & Early Access to WealthCon classes</li>
							<li>You can attend any How to Make Millions in the Stock Market Seminar for free</li>
							<li>You can attend any Truly Rich Coffee Club session for free</li>
							<li>Exclusive 1-on-1 with Bro. Bo — choose between a personal breakfast (first come, first served) or a 30-minute Zoom session</li>
							<li>One-Time Payment, Lifetime Savings — never pay annual fees again, saving you more as the years go by</li>
						</ul>

						<p>The Truly Rich Club Gold Lifetime Membership is valued at Php 135,000.</p>
						<p>But for my birthday I'm giving a special rate of Php 114,000.00 when you upgrade between July 3 to 17, 2026 only.</p>
						<p>And yes, if you change your mind you have 365 days for a full refund. No questions asked.</p>
						<p>Secure your Lifetime Membership today while this offer lasts!</p>

						<button type="button" @click="getGoldLifetime" :disabled="upgradeGoldLifetimeForm.processing" class="btn btn-primary mb-4">
							<div v-if="upgradeGoldLifetimeForm.processing" class="spinner-border spinner-border-sm text-dark me-1" role="status" >
								<span class="sr-only">Please wait...</span>
							</div>Upgrade me now to the TRC Gold Lifetime Membership
						</button>

						<p>Unlock permanent peace of mind and a definitive step towards securing your abundance journey with me and our supportive community.</p>
						<p>This is more than a membership. It's a legacy investment.</p>
						<p>May you become truly rich,</p>
						<p>Bo Sanchez<br/>TrulyRichClub Founder</p>

						<button type="button" @click="getGoldLifetime" :disabled="upgradeGoldLifetimeForm.processing" class="btn btn-primary mb-4">
							<div v-if="upgradeGoldLifetimeForm.processing" class="spinner-border spinner-border-sm text-dark me-1" role="status" >
								<span class="sr-only">Please wait...</span>
							</div>Yes, count me in your 60th Birthday Bro. Bo!
						</button>

					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { watch, onMounted, ref, reactive } from 'vue'
	import AuthPlainLayout from '../../Layouts/AuthPlainLayout'
	import { createToaster } from '@meforma/vue-toaster'
	import { useForm, usePage } from '@inertiajs/inertia-vue3'
	import Stripe from '../../Shared/Components/Stripe'

	export default{
		props:{
			cur_year 		: String,
			user 			: Object,
			member 			: Object,
			flash 			: Object,
			errors 			: Object,
			gold_lifetime 	: Object,
			ops_lifetime 	: Object,
			is_allowed 		: Number,
		},
		layout: AuthPlainLayout,
		setup(props) {

			const capitalized = (name)=>{
		      let capitalizedFirst = name[0].toUpperCase();
		      let rest = name.slice(1);

		      return capitalizedFirst + rest;
		    }

		    const deleteCreditCardModal = ref(null);

			const upgradeGoldLifetimeForm = useForm({
				subscription 	: props.member.prod_id,
				payment_method 	: 'BANK_TRANSFER',
				pmethod 		: null,
				pchannel 		: null,
				token 			: null,
				use_existing_card: props.member.has_card?true:false,
				action 	 		: 'gold_lifetime',
				loc 	 		: 'sales_page',
				rebates 		: props.member.rebates,
			});

			const getGoldLifetime = () => {upgradeGoldLifetimeForm.post(route('member.post.upgrade'), {})}

			return{
				capitalized,
				upgradeGoldLifetimeForm,
				getGoldLifetime,
			}
		}
		
	}
</script>

<style>
	
	ul{
		padding-left: 64px;
	}
</style>
